import React from 'react';
import { Music } from 'lucide-react';
import { cx } from './classes';

// The amber music-note tile used for files that are about to be, or were just, analyzed
export const FileTile = () => (
  <span className="w-8 h-8 flex-none rounded-radius-sm bg-amber text-on-amber inline-flex items-center justify-center">
    <Music size={16} strokeWidth={2.5} aria-hidden="true" />
  </span>
);

/**
 * An uploaded file with its version ("kick_v2.wav  V2"). Quiet chips (older versions) have no amber
 * tile and softer text.
 */
export const FileChip = ({ filename, version, quiet = false, className }) => (
  <div className={cx('max-w-full flex items-center gap-space-2 px-space-3 py-space-2 rounded-radius-md bg-surface', className)}>
    {!quiet && <FileTile />}
    <span className={cx('min-w-0 truncate font-mono text-data-sm', quiet ? 'text-ink-soft' : 'text-ink')}>{filename}</span>
    {version != null && <span className="flex-none font-text text-caption text-muted">V{version}</span>}
  </div>
);
